import { Caption, ColorFamily, Frow, LabelTag, Tooltip } from '@pinpointhq/thumbtack';
import * as React from 'react';
import type { ITag } from '../../../../../javascript/interfaces';
import { SpecificTagCategory } from '../../../../admin/jobs/applications/tables/InterviewsTable';
import { useWidth } from '../../../hooks/useWidth';

export interface ITagsCellProps {
  limitTagsShown?: boolean;
  tags: ITag[];
  tagCategories?: SpecificTagCategory[];
}

export function LabelTagsCell({ tags = [], tagCategories, limitTagsShown = false }: ITagsCellProps) {
  const { elementRef: tagDivRef, width } = useWidth();
  const colorMap = (tagCategories || []).reduce((map, tagCategory) => {
    map[tagCategory.parameterizedName] = tagCategory.color;
    return map;
  }, {});

  // We know the tag width is 100px so we can calculate how many tags to show
  //
  const numberOfTagsToShow = Math.floor((width || 1) / 100);

  if (limitTagsShown && tags.length > numberOfTagsToShow) {
    return (
      <div ref={tagDivRef} data-testid={`${tags.length}-tags`}>
        <Frow gutters={4} verticalGutters={4} alignItems="center">
          {tags.slice(0, numberOfTagsToShow).map((tag: ITag, index) => {
            const color = tag.color || colorMap[tag.context] || ColorFamily.IVORY;
            return (
              <div key={index}>
                <LabelTag color={color} maxWidth={100}>
                  {tag.name}
                </LabelTag>
              </div>
            );
          })}
          <div>
            <Tooltip
              content={tags
                .slice(numberOfTagsToShow, tags.length)
                .map((tag) => tag.name)
                .join(', ')}
            >
              <Caption>+ {tags.length - numberOfTagsToShow} more</Caption>
            </Tooltip>
          </div>
        </Frow>
      </div>
    );
  }

  return (
    <Frow gutters={4} verticalGutters={4}>
      {tags.map((tag: ITag, index) => {
        const color = tag.color || colorMap[tag.context] || ColorFamily.IVORY;
        return (
          <div key={index}>
            <LabelTag color={color} maxWidth={100}>
              {tag.name}
            </LabelTag>
          </div>
        );
      })}
    </Frow>
  );
}
